document.addEventListener('DOMContentLoaded', function () {
    if (typeof Swiper === 'undefined') {
        return;
    }

    const sliders = document.querySelectorAll('.one-slide-slider');

    if (!sliders.length) {
        return;
    }

    sliders.forEach((sliderEl) => {
        if (sliderEl.closest('.acf-block-preview')) {
            return;
        }

        const slides = sliderEl.querySelectorAll('.swiper-slide');

        if (!slides.length) {
            return;
        }

        const hasMultipleSlides = slides.length > 1;
        const paginationEl      = sliderEl.parentElement?.querySelector('.one-slide-slider-pagination');

        const swiper = new Swiper(sliderEl, {
            slidesPerView : 1,
            spaceBetween  : 0,
            grabCursor    : true,
            allowTouchMove: true,
            autoHeight    : true,
            loop          : hasMultipleSlides,
            pagination    : paginationEl ? {
                el        : paginationEl,
                clickable : true,
            } : false,
            autoplay      : hasMultipleSlides ? {
                delay                : 5000,
                disableOnInteraction : false,
            } : false,
        });

        sliderEl.querySelectorAll('img').forEach((img) => {
            if (img.complete) {
                return;
            }

            img.addEventListener('load', () => swiper.updateAutoHeight());
        });
    });
});
